module.exports = __webpack_public_path__ + "img/icontype12.4e09c722.png";